/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateClientBadRequestErrorCode = (typeof CreateClientBadRequestErrorCode)[keyof typeof CreateClientBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateClientBadRequestErrorCode = {
  client_already_exists: "client_already_exists",
  invalid_birth_number: "invalid_birth_number",
  unsupported_address_country: "unsupported_address_country",
} as const;
